module.exports = __webpack_public_path__ + "media/images/autopilot_preview-email_sms-d-349415b243b59fe9e29084a7ef1def72.svg";